import { ICONS } from 'components/Icons';
import { Extra } from 'scenes/common/types';
import {
  MotorInsuranceType,
  OptionalExtra,
} from 'scenes/motor/flows/coverOptions/types';
import {
  hireCarInformation,
  windscreenInformation,
  under25Information,
  roadsideAssistInformation,
} from './OptionalExtrasContent';

export const getAvailableExtras = (
  insuranceType: MotorInsuranceType
): Extra[] => {
  const roadSide = {
    code: OptionalExtra.RoadSide,
    label: 'Roadside Assistance',
    image: ICONS.OPTIONAL_EXTRA.MOTOR.ROADSIDE_ASSIST,
    additionalText: 'Will add $81 to your quote ',
    content: roadsideAssistInformation,
  };

  return insuranceType === MotorInsuranceType.Comprehensive
    ? [
        {
          code: OptionalExtra.HireCar,
          label: 'Hire car after an incident',
          image: ICONS.OPTIONAL_EXTRA.MOTOR.HIRE_CAR,
          content: hireCarInformation,
        },
        {
          code: OptionalExtra.WindScreen,
          label: 'Damage to windscreen or window glass - one excess free claim',
          image: ICONS.OPTIONAL_EXTRA.MOTOR.WINDSCREEN,
          content: windscreenInformation,
        },
        roadSide,
        {
          code: OptionalExtra.Under25,
          label: 'Cover for drivers under 25 years old',
          image: ICONS.OPTIONAL_EXTRA.MOTOR.UNDER_25,
          content: under25Information,
        },
      ]
    : [roadSide];
};
